// Paquets-années (PA) : nombre de paquets de 20 cigarettes fumés par jour
// multiplié par le nombre d'années de tabagisme. Une cigarette roulée compte
// comme une cigarette.
export const CIGARETTES_PAR_PAQUET = 20;

// Programme pilote national Impulsion (INCa, 2026) : 50-74 ans, fumeur ou
// sevré depuis moins de 15 ans, au moins 20 PA.
export const SEUIL_DEPISTAGE = 20;

// A period: { perDay, years }. Periods that are not fully filled in are ignored.
export function isComplete(p) {
  return p.perDay > 0 && p.perDay <= 200 && p.years > 0 && p.years <= 90;
}

export function packYears(periods) {
  return periods.filter(isComplete).reduce((sum, p) => sum + (p.perDay / CIGARETTES_PAR_PAQUET) * p.years, 0);
}

export function totalCigarettes(periods) {
  return periods.filter(isComplete).reduce((sum, p) => sum + p.perDay * 365.25 * p.years, 0);
}

export function totalYears(periods) {
  return periods.filter(isComplete).reduce((sum, p) => sum + p.years, 0);
}

// Repères descriptifs, pas une classification officielle : seul le seuil de
// 20 PA a une portée pratique (dépistage du cancer du poumon).
export function bandFor(pa) {
  if (pa < 10) return { key: "low", label: "Moins de 10 paquets-années" };
  if (pa < SEUIL_DEPISTAGE) return { key: "mid", label: "Entre 10 et 20 paquets-années" };
  return { key: "high", label: "20 paquets-années ou plus" };
}

// Prix moyen du paquet de 20 en France (douanes, juin 2026 : 12,47 €), pré-rempli
// et modifiable : il varie selon la marque, et le tabac à rouler coûte moins cher.
export const PRIX_PAQUET_DEFAUT = "12,50";

// Le rythme actuel est celui de la dernière période renseignée.
export function currentPerDay(periods) {
  const complete = periods.filter(isComplete);
  return complete.length ? complete[complete.length - 1].perDay : 0;
}

export function costPerYear(perDay, packPrice) {
  return (perDay / CIGARETTES_PAR_PAQUET) * packPrice * 365.25;
}

// Au prix actuel : surestime la dépense réelle passée, le paquet ayant
// beaucoup augmenté (environ 3 € en 2000).
export function totalCostAtPrice(periods, packPrice) {
  return (totalCigarettes(periods) / CIGARETTES_PAR_PAQUET) * packPrice;
}
